import { Injectable } from '@angular/core';
import {
    ComplianceAccessibilityService,
} from '@client/app/blocks/service/compliance/compliance-accessibility/compliance-accessibility.service';

@Injectable({
    providedIn: 'root',
})
export class ComplianceService {
    constructor (
        private complianceAccessibilityService: ComplianceAccessibilityService,
    ) { }

    qaHistoryCompliance (history: any): [number, number] | false {
        if (history.compliance_percentage?.qa_pages) {
            return [history.compliance_percentage.qa_pages, 100 - history.compliance_percentage.qa_pages];
        }
        return false;
    }

    accessibilityHistoryCompliance (history: any): [number, number] | false {
        if (history.compliance_percentage?.accessibility_pages) {
            return [
                history.compliance_percentage.accessibility_pages.error_and_warning_and_review,
                100 - history.compliance_percentage.accessibility_pages.error_and_warning_and_review,
            ];
        }
        return false;
    }

    seoHistoryCompliance (history: any): [number, number] | false {
        if (history.compliance_percentage?.seo_issues) {
            return [history.compliance_percentage.seo_issues, 100 - history.compliance_percentage.seo_issues];
        }
        return false;
    }

    policyHistoryCompliance (history: any): [number, number] | undefined {
        if (history.compliance_percentage?.policies) {
            return [history.compliance_percentage.policies, 100 - history.compliance_percentage.policies];
        }
    }

    accessibilityCompliance (resultType: any, pageCountAttr: string, accessibilityChecks: any, summary: any): [number, number] {
        const compliance = this.complianceAccessibilityService.getPercentageFromResultType(
            resultType,
            pageCountAttr,
            accessibilityChecks,
            summary,
        );
        return [compliance, 100 - compliance];
    }

    policyCompliance (policies: any[], pagesCount: number, linksCount: number): [number, number] {
        const percentage = this.policyCompliancePercentage(policies, pagesCount, linksCount);
        return [percentage, 100 - percentage];
    }

    policyCompliancePercentage (policies: any[], pagesCount: number, linksCount: number): number {
        const contentWithErrors = policies.reduce((num, policy) => {
            if (policy.subject === 'link') {
                return num + (parseInt(policy.matches_count) / linksCount) * 100;
            }
            return num + (parseInt(policy.matches_count) / pagesCount) * 100;
        }, 0);

        const score = 100 - contentWithErrors / policies.length;
        return isNaN(score) ? 0 : score;
    }

    accessibilityCompliancePercentageFromResultType (resultTypes: any, pageCountAttr: string, accessibilityChecks: any, summary: any): number {
        const score = this.complianceAccessibilityService.getPercentageFromResultType(
            resultTypes,
            pageCountAttr,
            accessibilityChecks,
            summary,
        );
        return isNaN(score) ? 0 : score;
    }

    seoCompliance (summary: any, checkpoints: any, history: any): [number, number] {
        const percentage = this.seoCompliancePercentage(summary, checkpoints, history);
        return [percentage, 100 - percentage];
    }

    seoCompliancePercentage (summary: any, checkpoints: any, history: any): number {
        return summary.compliance_percentage;
    }
}
